import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { CheckCircle } from 'lucide-react';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const userEmail = localStorage.getItem('signup_email'); // Get email from localStorage

  useEffect(() => {
    // Auto-redirect to insurance upload after 3 seconds
    const timer = setTimeout(() => {
      navigate(`/signup?role=carrier&step=3&email=${encodeURIComponent(userEmail || '')}`);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [navigate, userEmail]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="container mx-auto px-4 sm:px-6 py-12">
        <div className="max-w-2xl mx-auto">
          <Card className="p-8 text-center">
            <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" />
            <h1 className="text-3xl font-bold text-[#1e3a5f] mb-4">
              Payment Complete!
            </h1>
            <p className="text-gray-600 mb-4">
              Your payment has been successfully processed.
            </p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-yellow-800 font-semibold mb-2">
                ⚠️ Important: Complete Your Registration
              </p>
              <p className="text-sm text-yellow-700">
                Your subscription will NOT be activated until you:
              </p>
              <ul className="text-sm text-yellow-700 mt-2 ml-4 list-disc text-left">
                <li>Upload your insurance documents</li>
                <li>Register your equipment</li>
                <li>Get approved by our admin team</li>
              </ul>
            </div>
            
            <p className="text-gray-600 mb-6">
              Redirecting you to complete insurance upload...
            </p>
            
            <div className="space-y-3">
              <Button
                onClick={() => navigate(`/signup?role=carrier&step=3&email=${encodeURIComponent(userEmail || '')}`)}
                className="w-full bg-red-600 hover:bg-red-700 text-white"
              >
                Continue to Insurance Upload →
              </Button>
            </div>

            {sessionId && (
              <p className="text-xs text-gray-500 mt-6">
                Session ID: {sessionId}
              </p>
            )}
          </Card>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default SubscriptionSuccess;
